import React, { ChangeEvent, forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import { Autocomplete, Box, Button, Grid, IconButton, InputAdornment, MenuItem, Select, SelectChangeEvent, Stack, TextareaAutosize, TextField, Tooltip, Typography } from "@mui/material";
import { AldivalidateStep2, validateStep2, ValidationError } from "../../ScoreCardValidation/ValidationSchema.tsx";
import QuestionItem from "./QuestionItem.tsx";
import ALDIQuestionItem from "./ALDIQuestionItem.tsx";
import Menue from "../../Sidemenue/menue.tsx";
import { Cancel, KeyboardArrowDown, KeyboardArrowUp, Search, Send, UnarchiveOutlined } from "@mui/icons-material";
import { FieldError } from "../../ScoreCardValidation/ValidationErrors.tsx";
import Loading from "../../Loader/Loading.tsx";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ApiScoreCardStep1, ApiUpdateReportQuestion } from "../../../apiService/Core/CustomApiScoreCards.tsx";

interface QuestionsBankProps {
  questionsData: any;
  currentCategoryIndex: number;
  uploadedFiles: Record<string, File[]>;
  answers: Record<string, any>;
  setAnswer: any;
  staffMemberDesc: any;
  setStaffMemberDesc: any;
  clientGroup: string;
  reportOtherDetails: any
  reportGroup: string;
  setUploadedFiles: any;
  reorderFiles: (section: any, from: any, to: any, questionId: any) => void
  setValidationErrors: (value: any) => void;
  setShowValidationErrors: (value: boolean) => void;
  setCurrentCategoryIndex: (value: any) => void;
  onAnswerChange: (questionId: any, value: any) => void;
  onCommentChange: (questionId: number, comment: string) => void;
  onFileUpload: (
    event: React.ChangeEvent<HTMLInputElement>,
    section: string
  ) => void;
  onFileUpdate: (
    event: React.ChangeEvent<HTMLInputElement>,
    section: string,
    index: number
  ) => void;
  onPreviousCategory: () => void;
  onNextCategory: () => void;
  onRemoveFile: (section: string, index: number) => void;
  validationErrors?: ValidationError[];
  showPreview?: any;
  setArchieveImages: any;
  archieveImages: any;
  selectedMoveImages: any;
  setSelectedMoveImages: any;
  clientEntityName: any
  oldmaxScore: any;
  selected: any;
  AiReviews: any;
}

// Update the QuestionsBank component to pass validation errors to QuestionItem
const QuestionsBank = forwardRef<any, QuestionsBankProps>(
  ({
    questionsData,
    currentCategoryIndex,
    uploadedFiles,
    answers,
    reportGroup,
    setAnswer,
    staffMemberDesc,
    setStaffMemberDesc,
    clientGroup,
    reportOtherDetails,
    setUploadedFiles,
    reorderFiles,
    onAnswerChange,
    onCommentChange,
    onFileUpload,
    onFileUpdate,
    onPreviousCategory,
    onNextCategory,
    onRemoveFile,
    validationErrors,
    showPreview,
    setValidationErrors,
    setShowValidationErrors,
    setCurrentCategoryIndex,
    setArchieveImages,
    archieveImages,
    setSelectedMoveImages,
    clientEntityName,
    oldmaxScore,
    selected,
    AiReviews
  }, ref) => {

    const totalAnsweredCount = Object.values(answers).filter(obj => obj.isAnswered === true).length;
    const totalunAnsweredCount = Object.values(answers).filter(obj => obj.isAnswered === false).length;
    const [selectedQuestion, setSelectedQuestion] = useState<any>(selected || '')
    const [selectedmovequestion, setSelectedmovequestion] = useState<any>('')
    const questionRefs = useRef<Record<string, HTMLDivElement | null>>({});
    const bottomRef = useRef<HTMLDivElement | null>(null);
    const topRef = useRef<HTMLDivElement | null>(null);
    const [focused, setFocused] = useState(false);
    const loading = useSelector((state: any) => state.loader.isLoading);
    const [selectedimage, setseletedimage] = useState<any>([])
    const [isSuccess, setisSuccess] = useState<boolean>(false)
    const isAdmin = localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor' || localStorage.getItem("liveuserRole") === 'clientadmin'



    const totalQuestionsCount = questionsData?.totalQuestionsCount;
    // const totalAnsweredCount = questionsData.totalAnsweredCount;
    // const totalunAnsweredCount = questionsData.totalUnansweredCount;

    // Get current category
    const currentCategory = questionsData?.questions[currentCategoryIndex];

    // Add a function to check if a question has image validation errors
    const getQuestionImageErrors = (questionId: number) => {
      return (
        validationErrors?.filter(
          (error) => error.field === `question_${questionId}_images`
        ) || []
      );
    };
    const getUniqueLabels = (questionsData: any, reportGroup: string) => {
      let allQuestions: any[] = [];

      if (reportGroup === "MM" || reportGroup === "EXTENDED" || reportGroup === "JBHIFI") {
        // Sort categories first by name
        // const sortedCategories = [...questionsData.questions].sort((a, b) =>
        //   a.categoryName.localeCompare(b.categoryName)
        // );
        const sortedCategories = Array.from(
          new Map(
            questionsData.questions.map((item: any) => [item.categoryName, item])
          ).values()
        );

        sortedCategories.forEach((category) => {
          const sortedQs = [...category.questions].sort(
            (a, b) => a.displayOrder - b.displayOrder
          );
          allQuestions.push(...sortedQs);
        });
      } else {
        // Direct sort by displayOrder
        questionsData.questions.forEach((category: any) => {
          allQuestions.push(...category.questions);
        });
        allQuestions.sort((a, b) => a.displayOrder - b.displayOrder);
      }

      // Generate unique labels
      const uniqueLabels = Array.from(
        new Set(allQuestions.map((q, index) => `${(reportGroup === "MM" || reportGroup === "EXTENDED" || reportGroup === "JBHIFI") ? index + 1 : q.displayOrder}: ${q.questions}`))
      );

      return uniqueLabels;
    };

    // Usage
    const uniqueLabels = getUniqueLabels(questionsData, reportGroup);
    // const uniqueLabels = Array.from(
    //   new Set(
    //     questionsData?.questions.flatMap((question: any) =>
    //       question.questions.map((q: any) => `${q.displayOrder}: ${q.questions}`)
    //     )
    //   )
    // );

    const aldiuniqueLabels = Array.from(
      new Set(
        questionsData.questions.flatMap((question: any) =>
          question.questions.map((q: any) => `${q.questionLabel}: ${q.questions}`)
        )
      )
    );
    const uniqueLabels2 = Array.from(
      new Set(
        questionsData.questions.flatMap((question: any) =>
          question.questions.map((q: any) => `${q.questionLabel}`)
        )
      )
    );

    useEffect(() => {
      if (selected) {
        handleSelectChange(selected)
      }
    }, [selected]);

    const handleSelectChange = (newValue: any) => {
      if (newValue !== undefined || newValue !== null) {

        const label = newValue?.split(':')[0];
        // Scroll to the corresponding question
        // const questionId = questionsData.questions.flatMap((question: any) =>
        //   question.questions.map((q: any) => `${q.questionLabel}: ${q.questions}`))
        
        const ref = questionRefs.current[(reportGroup === "MM" || reportGroup === "EXTENDED" || reportGroup === "JBHIFI") ? Number(label - 1) : label?.trim()];
        if (ref) {
          ref.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    };


    useEffect(() => {
      if (validationErrors && validationErrors.length > 0) {
        const firstError = validationErrors.find((err) =>
          err.field.startsWith("question_")
        );

        if (firstError) {
          const match = firstError.field.match(/question_(\d+)/);
          if (match) {
            const questionId = Number(match[1]);

            const ref = questionRefs.current[questionId];
            if (ref) {
              ref.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }
        }
      }
    }, [validationErrors])

    const scrollToQuestion = (questionId: string) => {
      const element = questionRefs.current[questionId];

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    };


    useImperativeHandle(ref, () => ({
      scrollToQuestion,
    }));



    const CheckError = () => {
      const allCategoriesValidation: any = [];
      let step2HasErrors = false;
      let errorCategoryIndex = -1;

      if (questionsData) {
        // Flatten all questions with category info, deduplicate, and sort by displayOrder
        const orderedQuestions = Array.from(
          new Map(
            questionsData.questions
              .flatMap((category: any) =>
                category.questions.map((q: any) => ({
                  ...q,
                  categoryName: category.categoryName,
                }))
              )
              .map((q: any) => [q.questionId, q]) // deduplicate by questionId
          ).values()
        )
          .filter((q: any) => q.displayOrder !== undefined)
          .sort((a: any, b: any) => a.displayOrder - b.displayOrder);

        for (let i = 0; i < orderedQuestions.length; i++) {
          const question: any = orderedQuestions[i];

          // Find the category index for this question
          const categoryIndex = questionsData.questions.findIndex(
            (cat: any) => cat.categoryName === question.categoryName
          );

          const categoryValidation = AldivalidateStep2(answers, questionsData);

          if (!categoryValidation.isValid) {
            step2HasErrors = true;
            if (errorCategoryIndex === -1) {
              errorCategoryIndex = categoryIndex; // store first category with errors
            }
            allCategoriesValidation.push(...(categoryValidation.errors || []));
          }
          else {
            setisSuccess(true)
          }
        }
      }



      if (step2HasErrors) {
        setValidationErrors(allCategoriesValidation);
        setShowValidationErrors(true);
        setCurrentCategoryIndex(errorCategoryIndex);
        return;
      }
    }


    const findQuestionIdByLabel = (label: string) => {
      for (const section of questionsData.questions) {
        for (const q of section.questions) {
          if (q.questionLabel === label) {
            return q.questionId;
          }
        }
      }
      return null;
    };

    const updateQuestion = async (data: any) => {
      try {
        const res = await ApiUpdateReportQuestion(data, clientGroup)
      } catch (error: any) {
        console.log("Error ON Blur Save ", error.message)
      }
    }

    const getQuestionFromLabel = (
      label: string,
    ) => {
      let allQuestions: any[] = [];

      if (reportGroup === "MM" || reportGroup === "EXTENDED" || reportGroup === "JBHIFI") {
        const sortedCategories = Array.from(
          new Map(
            questionsData.questions.map((item: any) => [item.categoryName, item])
          ).values()
        );

        sortedCategories.forEach((category) => {
          const sortedQs = [...category?.questions].sort(
            (a, b) => a.displayOrder - b.displayOrder
          );
          allQuestions.push(...sortedQs);
        });
      } else {
        questionsData.questions.forEach((category: any) => {
          allQuestions.push(...category.questions);
        });
        allQuestions.sort((a, b) => a.displayOrder - b.displayOrder);
      }

      // Extract number from label (before ":")
      const labelNumber = parseInt(label.split(":")[0]);

      if (reportGroup === "MM" || reportGroup === "EXTENDED" || reportGroup === "JBHIFI") {
        // index आधारित mapping
        return allQuestions[labelNumber - 1]?.questionId || null;
      } else {
        // displayOrder आधारित mapping
        return allQuestions.find(q => q.displayOrder === labelNumber)?.questionId || null;
      }
    };

    const handleunarchieveimages = async () => {
      const questionId = reportGroup === "ALDI" ? findQuestionIdByLabel(selectedmovequestion) : getQuestionFromLabel(selectedmovequestion)
      if (questionId && selectedimage.length > 0) {
        const updateddata = {
          reportHeaderId: questionsData?.reportHeader?.reportHeaderId,
          platform: "web",
          platformAppType: null,
          reportDtlId: answers[questionId]?.reportDtlId,
          value: answers[questionId]?.value,
          score: answers[questionId]?.score,
          comment: answers[questionId]?.comment,
          isAnswered: answers[questionId]?.isAnswered,
          maxScore: answers[questionId]?.maxScore,
          photoUrl: [
            ...(answers[questionId]?.photoUrl ? answers[questionId]?.photoUrl?.split(",") : []),
            ...selectedimage?.map((item: any) => item?.imageUrl),
          ].join(","),
        };

        updateQuestion(updateddata)

        await setAnswer((prev) => {
          const existingAnswer = prev[questionId] || {};
          return {
            ...prev,
            [questionId]: {
              ...existingAnswer,
              photoUrl: [
                ...(existingAnswer.photoUrl ? existingAnswer.photoUrl.split(",") : []),
                ...selectedimage.map((item: any) => item.imageUrl),
              ].join(","),
            },
          };
        });

        await setUploadedFiles((prevState) => {
          const existingFiles =
            prevState.questionFiles?.[questionId] && Array.isArray(prevState.questionFiles[questionId])
              ? prevState.questionFiles[questionId]
              : [];

          const newFiles = [
            ...existingFiles,
            ...selectedimage.map((img: any) => img.imageUrl),
          ];

          return {
            ...prevState,
            questionFiles: {
              ...prevState.questionFiles,
              [questionId]: newFiles,
            },
          };
        });

        // await setArchieveImages((prev) => {
        //   prev.filter((img) => !selectedimage.includes(img.imageUrl))
        // })
        setseletedimage([])
        toast.success("Images unarchived Successfully ", questionId)
      }
      else if (selectedimage.length > 0) {
        toast.error("Please Select question label")
      }
      else {
        toast.error("Please Select Image")
      }

    }

    const handleremoveselected = (index, item) => {
      const updatedimages = selectedimage.filter((_, index2) => index2 !== index);
      setseletedimage(updatedimages);

      setArchieveImages((prev) => [...prev, item]);
    }

    const handleChange2 = async (event: any) => {
      setStaffMemberDesc(event.target.value);
      try {
        const data =
        {
          "reportHeaderId": questionsData?.reportHeader?.reportHeaderId,
          platform: "web",
          platformAppType: null,
          teamMemberDescription: event.target.value,

        }
        const res = await ApiScoreCardStep1(data, clientGroup)

      } catch (error: any) {
        toast.error(error?.message)
      }
    };
    useEffect(() => {
      setSelectedMoveImages(selectedimage)
    }, [selectedimage])

    return (
      <Box className='d-flex h-100 mb-0 p-0 align-items-start' position={'relative'} gap={2}>
        <Stack spacing={2} className="mb-0 w-100">
          {(localStorage.getItem('liveuserRole') !== 'admin' && localStorage.getItem('liveuserRole') !== 'superadmin' && localStorage.getItem("liveuserRole") !== 'editor') && (<Box>
            <Box

              className={showPreview ? '' : "questionBankHeader bg-second"}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: '#fff',
                //bgcolor: "#f5f5f5",
                p: { xs: 1, sm: 2 },
                marginBottom: "20px 0px !important",
                borderRadius: "10px",

              }}
            >
              {/* Left section - Step indicator */}
              {/* {(reportGroup !== "ALDI" && reportGroup !== "TRANSPORT") && (
              <Typography className="text-dark" sx={{ fontWeight: 600, fontSize: { xs: 14, lg: 16 } }}>
                {`${currentCategoryIndex + 1}/${questionsData.questions.length
                  } - ${currentCategory?.categoryName.toUpperCase()}`}
              </Typography>
            )} */}

              {/* Middle section - Question statistics */}
              <Box sx={{ display: "flex", alignItems: "center", fontSize: 14 }}>
                <Typography component="span" className="fs-16">
                  Total Questions: {totalQuestionsCount}
                </Typography>
                <Typography component="span" className="fs-16" sx={{ mx: 0.5, color: "#fff" }}>
                  |
                </Typography>
                <Typography component="span" className="fs-16" sx={{ mx: 0.5, color: "#fff" }}>
                  Answered: {totalAnsweredCount}
                </Typography>
                <Typography component="span" className="fs-16" sx={{ mx: 0.5, color: "#fff" }}>
                  |
                </Typography>
                <Typography component="span" className="fs-16" sx={{ color: "#fff" }}>
                  Remaining: {totalunAnsweredCount}
                </Typography>
              </Box>
            </Box>
          </Box>
          )}
          {/* {reportGroup === "ALDI" && ( */}
          <Box display={{ xs: "flex", md: "none" }} className='align-items-center mb-2 justify-content-end' gap={2}>
            <IconButton className="border text-light" onClick={() => topRef.current?.scrollIntoView({ behavior: "smooth" })}><KeyboardArrowUp /></IconButton>
            <IconButton className="border text-light"
              onClick={() => bottomRef.current?.scrollIntoView({ behavior: "smooth" })}><KeyboardArrowDown /></IconButton>
            <Autocomplete
              value={selectedQuestion ? selectedQuestion.split(':')[0] : ''}
              onChange={(event: any, newValue) => { setSelectedQuestion(newValue); handleSelectChange(newValue); }}
              options={uniqueLabels}
              freeSolo
              sx={{ bgcolor: 'white', width: focused ? "100%!important" : 'auto', left: '0', top: '16%', position: focused ? 'absolute' : 'relative' }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder={focused ? "Search..." : ""}
                  onFocus={() => setFocused(true)}
                  onBlur={() => setFocused(false)}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: !focused ? (
                      <InputAdornment position="start">
                        <IconButton className="m-0 p-0">
                          <Search />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                />
              )}
            />
            <Button onClick={() => CheckError()} className="button-primary px-4 py-2">Verify</Button>
          </Box>
          {/* // )} */}
          <Box className='w-100'
            height={(localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor' || localStorage.getItem("liveuserRole") === 'clientadmin') ? 'fit-content' : 'calc(100vh - 310px)'}
            sx={{ overflowY: 'auto' }}>
            {clientGroup === "ALDI" && !isAdmin && (
              <Box data-field="staffMemberDesc">
                <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>
                  {reportGroup === "ALDI" ? "Auditor's notes" : reportGroup === "BLOOMS" ? "Pharmacists/Team Members" : 'Staff Member Description'}<span style={{ color: "#D32F2F" }}> *</span>
                </Typography>

                <TextareaAutosize
                  minRows={5}
                  placeholder="Write Here..."
                  value={staffMemberDesc}
                  onChange={(e) => setStaffMemberDesc(e.target.value)}
                  onBlur={handleChange2}
                  className={`summeryBox ${validationErrors?.some((e) => e.field === "staffMemberDesc")
                    ? "error-border"
                    : ""
                    }`}
                  style={{
                    borderColor: validationErrors?.some(
                      (e) => e.field === "staffMemberDesc"
                    )
                      ? "#d32f2f"
                      : undefined,
                    borderRadius: "10px",
                  }}
                />
                <FieldError errors={validationErrors} field="staffMemberDesc" />
              </Box>
            )}
            {clientGroup === "ALDI" && clientEntityName === "Audit" && (<img className="w-100 my-1 mx-auto" src='https://mmfiles-production.s3.ap-southeast-2.amazonaws.com/ProjectFiles/WhatsApp%20Image%202025-08-13%20at%2019.39.41.jpeg-0791748b-255b-4139-93ce-f3774be4be6d' />)}

            {reportOtherDetails?.reportMessage && (
              <Box
                sx={{
                  p: 2,
                  border: "1px solid #ccc",
                  backgroundColor: 'rgba(125,251,90)',
                  borderRadius: 1,
                  fontSize: "0.875rem",
                  fontFamily: "Roboto, sans-serif",
                  whiteSpace: "pre-wrap",
                }}
                dangerouslySetInnerHTML={{ __html: reportOtherDetails.reportMessage }}
              />
            )}
            <Stack
              bgcolor={"transparent"}
              spacing={3}
              className={showPreview ? "" : "questionBankContent"}
              padding={{ xs: "0px !important", md: "auto" }}
            >

              <Box ref={topRef}></Box>
              {(() => {
                // const uniqueCategories = Array.from(
                //   new Set(questionsData.questions.map((category: any) => category.categoryName))
                // );
                // return Array.from(
                //   new Map(
                //     questionsData.questions
                //       .flatMap((category) =>
                //         category.questions.map((q: any) => ({
                //           ...q,
                //           categoryName: category.categoryName
                //         }))
                //       )
                //       .map((q) => [q.questionId, q])
                //   ).values()
                // )
                //   .filter((q: any) => q.displayOrder !== undefined)
                //   .sort((a: any, b: any) => a.displayOrder - b.displayOrder)
                //   .map((question: any, index: number) => (

                // 1. Unique categories (used in both cases)
                const uniqueCategories = Array.from(
                  new Set(
                    questionsData.questions.map(
                      (category: any) => category.categoryName
                    )
                  )
                );
                // 2. Flatten questions + attach categoryName
                const allQuestions = questionsData.questions.flatMap((category: any) =>
                  category.questions.map((q: any) => ({
                    ...q,
                    categoryName: category.categoryName,
                  }))
                );

                // 3. Remove duplicates by questionId
                const uniqueQuestions = Array.from(
                  new Map(
                    allQuestions.map((q: any) => [q.questionId, q])
                  ).values()
                ).filter((q: any) => q.displayOrder !== undefined);

                let finalQuestions: any[] = [];

                // 4. CONDITIONAL SORTING
                if (reportGroup !== "MM" && reportGroup !== "EXTENDED" && reportGroup !== "JBHIFI") {
                  // 🔹 ALDI → existing behavior (global sort)
                  finalQuestions = uniqueQuestions.sort(
                    (a: any, b: any) => a.displayOrder - b.displayOrder
                  );
                } else {
                  // 🔹 Non-ALDI → category-wise ascending
                  uniqueCategories.forEach((categoryName) => {
                    const categoryQuestions = uniqueQuestions
                      .filter((q: any) => q.categoryName === categoryName)
                      .sort((a: any, b: any) => a.displayOrder - b.displayOrder);

                    finalQuestions.push(...categoryQuestions);
                  });
                }

                // 5. Render
                return finalQuestions.map((question: any, index: number) => (
                  // <div className={`${AiReviews && AiReviews?.summaryIssues?.some(
                  //   (issue: any) => issue.reportDtlId === question?.reportDtlId
                  // ) ? "animated-gradient" : ""}`}>
                    // <Box className='w-100'>
                      <ALDIQuestionItem
                        questionsData={questionsData}
                        questionRefs={questionRefs}
                        key={question.questionId}
                        AiReviews={AiReviews}
                        question={question}
                        index={index}
                        uniqueCategories={uniqueCategories}
                        answers={answers}
                        setAnswer={setAnswer}
                        setUploadedFiles={setUploadedFiles}
                        reorderFile={reorderFiles}
                        reportOtherDetails={reportOtherDetails}
                        uploadedFiles={uploadedFiles}
                        onAnswerChange={onAnswerChange}
                        onCommentChange={onCommentChange}
                        onFileUpload={onFileUpload}
                        onFileUpdate={onFileUpdate}
                        setArchieveImages={setArchieveImages}
                        clientGroup={reportGroup}
                        onRemoveFile={onRemoveFile}
                        oldmaxScore={oldmaxScore}
                        validationErrors={[
                          ...(validationErrors || []),
                          ...getQuestionImageErrors(question.questionId),
                        ]}
                        ref={(el) => {
                          if (el) {
                            // always store by questionId (needed for validation errors)
                            questionRefs.current[question.questionId] = el;

                            // also store by label (for dropdown navigation)
                            if (question.questionLabel) {
                              questionRefs.current[question.questionLabel] = el;
                            }
                            else if (question.displayOrder && reportGroup !== "MM" && reportGroup != "EXTENDED" && reportGroup !== "JBHIFI") {
                              questionRefs.current[question.displayOrder] = el;
                            }
                            else if (index !== undefined) {
                              questionRefs.current[index] = el;
                            }
                          }
                        }}
                      />
                    // </Box>
                  // </div>
                ));
              })()}
              <Box ref={bottomRef}></Box>
            </Stack>
            {/* ((reportGroup === "ALDI") || (reportGroup === "TRANSPORT")) && */}
            {(localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor') && (
              <Box className='border p-3'>
                <Box className='d-flex align-items-center justify-content-between'>
                  <Typography variant="h5">Question Archive Images</Typography>
                  <Box className='d-flex align-items-center' gap={1}>
                    <Autocomplete
                      value={selectedmovequestion ? selectedmovequestion.split(':')[0] : ''}
                      onChange={(event: any, newValue) => { setSelectedmovequestion(newValue); }}
                      options={reportGroup === "ALDI" ? uniqueLabels2 : uniqueLabels}
                      getOptionLabel={(option) => {
                        if (!option) return "";
                        return option.split(":")[0]; // 👈 only number
                      }}
                      freeSolo
                      sx={{ bgcolor: 'white', boxShadow: 'none', width: '130px', left: '0px', top: '16%', position: 'relative' }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder={"Move to"}

                          InputProps={{
                            ...params.InputProps,
                            startAdornment: null,
                            endAdornment: null,
                          }}
                        />
                      )}
                    />
                    <Tooltip title='move'>
                      <IconButton onClick={() => handleunarchieveimages()} className=""><Send /></IconButton>
                    </Tooltip>
                  </Box>

                </Box>
                <hr />
                {selectedimage.length > 0 && (
                  <>
                    <Typography>Selected Images</Typography>
                    <hr className="m-0 p-0 mb-3" />
                    <Grid className="w-100 mb-5" height={'50px'} spacing={1} container position={'relative'}>
                      {selectedimage?.map((item, index) => (
                        <Grid item className="h-100 image-container" position={'relative'} >
                          <Box className="h-100 border-10" width={'50px'} component={'img'} src={item?.imageUrl} key={index} />
                          <Box position={'absolute'} top={8} right={8} className='d-flex cancel-btn justify-content-center'><IconButton onClick={() => { handleremoveselected(index, item) }}><Cancel sx={{ fontSize: '18px' }} /></IconButton></Box>
                        </Grid>
                      ))}
                    </Grid>
                  </>

                )}
                <Grid className="w-100" spacing={2} container position={'relative'}>
                  {archieveImages?.map((item, index) => (
                    <Grid item >
                      <Box height={'fit-content'}>
                        <Box height={125} width={150} className='border border-10'>
                          <Box className="w-100 border-10" component={'img'} style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }} src={item.imageUrl} key={index} />
                        </Box>
                        <Box className='d-flex justify-content-center mt-4'>
                          <Tooltip title='unarchive'>
                            <IconButton
                              onClick={() => {
                                setseletedimage((prev) => [...prev, item]);
                                setArchieveImages((prev) =>
                                  prev.filter((question) => question.imageUrl !== item.imageUrl)
                                );
                              }}><UnarchiveOutlined /></IconButton>
                          </Tooltip>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>

              </Box>
            )}

          </Box>

        </Stack>
        {(localStorage.getItem('liveuserRole') !== 'admin' && localStorage.getItem('liveuserRole') !== 'superadmin' && localStorage.getItem("liveuserRole") !== 'editor') && (
          <>
            <Box display={{ xs: "none", md: "flex" }} className='flex-column align-items-center mb-2 justify-content-end' gap={2}>

              <Button onClick={() => CheckError()} className="button-primary px-4 py-2">{isSuccess ? "Success" : "Verify"}</Button>
              <IconButton className="border text-light" onClick={() => topRef.current?.scrollIntoView({ behavior: "smooth" })}><KeyboardArrowUp /></IconButton>
              <IconButton className="border text-light"
                onClick={() => bottomRef.current?.scrollIntoView({ behavior: "smooth" })}><KeyboardArrowDown /></IconButton>

              <Autocomplete
                value={selectedQuestion ? reportGroup === "ALDI" ? selectedQuestion : selectedQuestion : ''}
                onChange={(event: any, newValue) => { setSelectedQuestion(newValue); handleSelectChange(newValue) }}
                options={reportGroup === "ALDI" ? aldiuniqueLabels : uniqueLabels}
                getOptionLabel={(option) => reportGroup !== "ALDI" ? option.split(':')[1] || option : option}
                freeSolo
                sx={{ bgcolor: 'white', boxShadow: focused ? "0px 0px 3px black, 0px 0px 10px black " : 'none', width: focused ? "100%!important" : '100px', left: '0px', top: localStorage.getItem('liveuserRole') !== 'admin' && localStorage.getItem('liveuserRole') !== 'superadmin' && localStorage.getItem("liveuserRole") !== 'editor' ? '16%' : '0px', position: focused ? 'absolute' : 'relative' }}
                slotProps={{
                  popper: {
                    sx: {
                      width: '83% !important',
                      '& .MuiAutocomplete-paper': {
                        width: '83% !important',
                        minWidth: '400px',
                      },
                    },
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder={focused ? "Search..." : ""}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: !focused ? (
                        <InputAdornment position="start">
                          <IconButton className="m-0 p-0">
                            <Search />
                          </IconButton>
                        </InputAdornment>
                      ) : null,
                    }}
                  />
                )}
              />
            </Box>
          </>
        )}
        {loading && localStorage.getItem('liveuserRole') !== 'admin' && localStorage.getItem('liveuserRole') !== 'superadmin' && localStorage.getItem("liveuserRole") !== 'editor' && <Loading />}
      </Box>
    );
  });

export default QuestionsBank;